import React from 'react';
import QNavListItems from '../../containers/Navigation/QNavListItems';
import QNavigation from './QNavigation';
import { useAppContext } from '../../libs/appContextLib';

/**
 * QNavigationWrapper
 *
 * Feature flag wrapper to switch between old and new navigation.
 * This allows for gradual rollout and A/B testing.
 *
 * Rollout Strategy:
 * 1. Dev/Test: Always show new navigation
 * 2. Beta: Show to @qflow.ai users only
 * 3. Gradual: Backend feature flag per customer
 * 4. Full: 100% rollout, remove legacy code
 *
 * Props: Same as QNavListItems/QNavigation
 */
function QNavigationWrapper(props) {
  const { currUser } = useAppContext();

  // Determine which navigation to show
  const useNewNavigation = getNavigationVersion(currUser);

  if (useNewNavigation) {
    return <QNavigation {...props} />;
  }

  return <QNavListItems {...props} />;
}

// Memoize wrapper to prevent re-renders from parent
export default React.memo(QNavigationWrapper);

/**
 * Determine which navigation version to show
 * Customize this logic based on your rollout strategy
 *
 * EXPORTED for use in App.js to conditionally show NavigationUpdateBanner
 */
export function getNavigationVersion(currUser) {
  // Strategy: Full production rollout
  // New navigation is now enabled for all users in all environments
  return true;
}

/**
 * Alternative: A/B Test Split
 * Randomly assign users to test/control groups
 */
export function getABTestGroup(userId) {
  // Simple hash-based assignment (deterministic)
  const hash = hashCode(userId);
  return hash % 2 === 0 ? 'control' : 'test';
}

function hashCode(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  return Math.abs(hash);
}
